module.exports = __webpack_public_path__ + "assets/images/plannerChangeColor-cc494e641617a5028707653f7104dde2.gif";